/*
 FileAssignment component
 url match: / or /login
 Displays email id and password field
 with FileAssignment button
*/
import { withRouter } from 'react-router-dom';
import React from 'react';
import { inject, observer } from 'mobx-react';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { settingsStyles } from '../../Styles/userStyles';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Loader from 'react-loader-spinner'
import InputAdornment from '@material-ui/core/InputAdornment';
import { ReactSVG } from 'react-svg';
import Images from '../../Theme/Images';
 import FormHelperText from '@material-ui/core/FormHelperText';
@inject('userStore', 'commonStore')
@observer
class ChangePasswordDialog extends React.Component {
    state = {
        oldPassword: '',
        newPassword: '',
        validationErrors: {},
        showPassword1: false,
        showPassword2: false,
    }

    handleChange = (field, event) => {
        event.stopPropagation();
        this.setState({
            [field]: event.target.value
        })
    }

    validateFields() {
        const { oldPassword, newPassword, validationErrors } = this.state;
        let valid = true;
        if (!oldPassword || oldPassword.length < 6 || oldPassword.length > 25) {
            validationErrors['oldPassword'] = "Please enter a valid password with min. 6 and max. 25 characters";
            this.setState({ validationErrors });
            valid = false;
        }
        else
            delete validationErrors['oldPassword']
        if (!newPassword || newPassword.length < 6 || newPassword.length > 25) {
            validationErrors['newPassword'] = "Please enter a valid password with min. 6 and max. 25 characters";
            this.setState({ validationErrors });
            valid = false;
        }
        else
            delete validationErrors['newPassword']
        if (valid) {
            delete validationErrors['newPassword'];
            delete validationErrors['oldPassword'];
            this.setState({ validationErrors });
        }
        return valid;
    }

    cancel = () => {
        this.setState({ validationErrors: {}, oldPassword: '', newPassword: '', showPassword1: false, showPassword2: false})
        this.closeDialog()
        this.props.userStore.openChangePasswordDialog(false)
    }

    changePassword = (e) => {
        e.preventDefault();
        const { oldPassword, newPassword } = this.state
        if (!oldPassword || !newPassword) {
            this.props.commonStore.handleOpenSnackBar("Please enter old and new passwords before proceeding", "info")
        }
        else if (this.validateFields()) {
            this.props.userStore.changePassword(oldPassword, newPassword)
        }
        else {
            console.log('error')
        }
    }

    closeDialog = () => {
        this.setState({
            oldPassword: '',
            newPassword: ''
        })
    }



    render() {
        const { classes, theme } = this.props;
        const { changePasswordDialog, inProgress } = this.props.userStore;
        const { oldPassword, newPassword, validationErrors, showPassword1, showPassword2 } = this.state
        return (
            <Dialog BackdropProps={{
                classes: {
                    root: classes.backdrop
                }
            }} disableBackdropClick={true} disableEscapeKeyDown={true} classes={{ paper: classes.dialog }} open={changePasswordDialog} onClose={this.closeDialog} aria-labelledby="form-dialog-title">
                <DialogTitle style={{ color: 'white' }}>
                    <div style={{ textAlign: 'center' }}>
                        <ReactSVG src={Images.lock} />
                        <div>Change Password</div>
                    </div>
                </DialogTitle>
                <DialogContent>
                    <form noValidate autoComplete="off" className={classes.formStyle}>
                        <TextField color="primary" style={{ paddingTop: 0, marginTop: 0 }} id="old"
                            label='Old Password'
                            margin="normal"
                            variant="filled"
                            InputProps={{
                                disableUnderline: true,
                                endAdornment: <InputAdornment position="end" >
                                    {!showPassword1 ? <ReactSVG src={Images.visibilityIcon} className={classes.showPassword} onClick={(e) => this.setState({ showPassword1: true })} /> :
                                        <ReactSVG src={Images.visibilityOffIcon} className={classes.showPassword} onClick={(e) => this.setState({ showPassword1: false })} />}
                                </InputAdornment>
                            }}
                            fullWidth
                            value={oldPassword}
                            type={showPassword1 ? 'text' : 'password'} name="password1"
                            onChange={(event) => this.handleChange('oldPassword', event)}
                        />
                        {validationErrors.oldPassword && <FormHelperText style={{ display: 'flex', color: 'red' }} id="email-input"><ReactSVG
                            beforeInjection={svg => {
                                svg.classList.add(classes.svg)
                            }}
                            src={Images.error} />&nbsp;{validationErrors.oldPassword}</FormHelperText>}
                        <TextField color="primary" style={{ paddingTop: 0, marginTop: 0 }} id="new"
                            label='New Password'
                            margin="normal"
                            variant="filled"
                            InputProps={{
                                disableUnderline: true,
                                endAdornment: <InputAdornment position="end" >
                                    {!showPassword2 ? <ReactSVG src={Images.visibilityIcon} className={classes.showPassword} onClick={(e) => this.setState({ showPassword2: true })} /> :
                                        <ReactSVG src={Images.visibilityOffIcon}  className={classes.showPassword} onClick={(e) => this.setState({ showPassword2: false })} />}
                                </InputAdornment>
                            }}
                            fullWidth
                            value={newPassword}
                            type={showPassword2 ? 'text' : 'password'} name="password"
                            onChange={(event) => this.handleChange('newPassword', event)}
                        />
                        {validationErrors.newPassword && <FormHelperText style={{ display: 'flex', color: 'red' }} id="email-input"><ReactSVG
                            beforeInjection={svg => {
                                svg.classList.add(classes.svg)
                            }}
                            src={Images.error} />&nbsp;{validationErrors.newPassword}</FormHelperText>}
                        <div className={classes.saveContainer} style={{ justifyContent: 'space-between' }}>
                            <Button variant="contained" onClick={this.cancel} className={classes.passwordButtons} > Cancel  </Button>
                            {
                                inProgress ?
                                    <Button variant="contained" className={classes.passwordButtons} style={{ backgroundColor: theme.palette.blue }}><Loader height={30} width={30} color={this.props.theme.palette.white} /></Button> :
                                    <Button variant="contained" onClick={this.changePassword} className={classes.passwordButtons} style={{ backgroundColor: theme.palette.blue }} type="submit" > Change Password  </Button>

                            }
                        </div>
                    </form>
                </DialogContent>

            </Dialog>

        )
    }
}
export default withStyles(settingsStyles, { withTheme: true })(withRouter(ChangePasswordDialog));
